<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn color="green" append-icon="mdi-pencil-outline" v-bind="props">
          Editar
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Editar StakeHolder Externo</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="nome"
                    required
                    label="Nome*"
                    :rules="nomeRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="email"
                    label="E-mail*"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Atualizar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module EditStakeHolderEModal
 * @desc Modal que recebe as informações do StakeHolder.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o diálogo
 * está aberto ou fechado.
 * @vue-data {string} [nome=''] - O nome do Stajeholder.
 * @vue-data {string} [email=''] - O email do Stajeholder.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o stakeholder
 * externo ainda está sendo editado.
 */
import axios from 'axios';

import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;
export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  emits: ['stakeholderEditado'],
  data: () => ({
    dialog: false,
    nome: '',
    email: '',
    isLoading: false,
    nomeRules: [
      (v) => !!v || 'Nome é obrigatório',
      (v) => (v && v.length <= 68) || 'Nome deve ter no máximo 68 caracteres',
    ],
    emailRules: [
      (v) => !!v || 'E-mail é obrigatório',
      (v) =>
        // eslint-disable-next-line max-len
        // Esta regra foi tirada de: https://stackoverflow.com/questions/50039793/email-validation-n-vuetify-js
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Este e-mail não é válido',
      (v) => (v && v.length <= 68) || 'E-mail deve ter no máximo 68 caracteres',
    ],
  }),
  mounted() {
    this.fetchStakeHolder(this.id);
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Pega o stakeholder por ID.
     *
     * @param {Number} id O id do projeto.
     */
    async fetchStakeHolder(id) {
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/stakeHolderE/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.nome = response.data.stakeHolderE.nome;
        this.email = response.data.stakeHolderE.email;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Envia o formulário.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          nome: this.nome,
          email: this.email,
        };
        try {
          this.isLoading = true;
          const response = await axios.put(
            `${apiUrl}/api/v1/stakeHolderE/${this.id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const idProjeto = this.$route.params.idProjeto;

          this.$toast.success(response.data.msg);
          this.$emit('stakeholderEditado');
          this.$router.push(`/projects/${idProjeto}/StackHolderE`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
